export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sensors.56e1c399.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};